import styled from "styled-components";


export const MaintainTopWrapper = styled.div`
  background : #ffe8ab;
  padding: 20px 40px;
  overflow: hidden;
  position : relative;
  width : 500px;
  @media screen and (max-width : 440px){
    padding: 20px;
    }
  `;
export const Logo  = styled.img`
    max-width: 160px;
    width :100%;
    text-align : left;
    padding : 10px 0;
    @media screen and (max-width : 440px){
      max-width: 100px;
    }
`
export const MaintainLogo  = styled.img`
    position : absolute;
    top:58px;
    width : 110px;
    height : 225px;
    left : 435px;
`

export const Title  = styled.div`
    font-size: 38px;
    font-weight: bold;
    white-space: pre-line;
    text-align : left;
    line-height : 42px;
    letter-spacing: -2px ;
    @media screen and (max-width : 440px){
      font-size : 22px;
      line-height : 28px;
    }
`
export const Text  = styled.div`
    font-size: 14px;
    white-space: pre-line;
    text-align : left;
    padding : 5px 0;
    letter-spacing: -1px ;
    @media screen and (max-width : 440px){
      font-size : 12px;
    }
`
export const MaintainBottomWrapper = styled.div`
  padding: 20px 40px;
  @media screen and (max-width : 440px){
    padding: 20px;
    }
`;

export const MaintainBottomTextWrap = styled.div`
  display : flex;
`;
export const MaintainBottomText1 = styled.div`
  padding-right: 20px;
  padding-top : 10px;
  padding-bottom : 10px;
  font-weight: 900;
  @media screen and (max-width : 440px){
    padding-right: 5px;
  padding-top : 5px;
  padding-bottom : 5px;
    }
`;
export const MaintainBottomText = styled.div`
  padding-right: 20px;
  padding-top : 10px;
  padding-bottom : 10px;
  font-weight: 500;
  font-family : "noto sans jskr";
  position : relative;
  top : 0px;
  @media screen and (max-width : 440px){
    padding-right: 5px;
  padding-top : 5px;
  padding-bottom : 5px;
    }
`;
